/* eslint-disable */
import { FormRecordFieldView, FormRecordFieldViewFactory, } from './form-utils';
import { ComponentFactoryResolver, ComponentRef, Injector, } from '@angular/core';
import { FormRecordMultiItemFieldComponent } from '../../admin/form/form-record/fields/multi-item/form-record-multi-item-field.component';
/* eslint-enable */

export class FormRecordMultiItemFieldViewFactory implements FormRecordFieldViewFactory {

  constructor(
    private injector: Injector,
    private cfr: ComponentFactoryResolver) {
  }

  createView(): ComponentRef<FormRecordFieldView> {
    const cmp = this.cfr.resolveComponentFactory(FormRecordMultiItemFieldComponent)
      .create(this.injector);
    return cmp;
  }

}
